const Approved = require('./approved');
const InProgress = require('./inprogress');
const Refused = require('./refused');

module.exports = {
  Approved,
  InProgress,
  Refused,
};
